import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";
import { useTranslation } from "react-i18next";
export function StickerSizeProvider({ size, children, className, }) {
    return (_jsx("div", { className: `@container-size ${className ?? ""}`, style: { "--sticker-h": size }, children: children }));
}
export function LiveSticker({ className }) {
    const { t } = useTranslation();
    return (_jsxs("div", { className: `${className ?? ""} flex flex-row items-center gap-[0.3em] rounded-sm bg-red-700 px-[0.6em] py-2 text-[calc(var(--sticker-h)*0.4)] leading-none text-gray-100`, children: [_jsx("svg", { viewBox: "0 0 8 8", className: "h-[0.5em] w-[0.5em] fill-gray-100", children: _jsx("circle", { cx: "4", cy: "4", r: "4" }) }), _jsx("span", { children: t("live") })] }));
}
export function ComingSoonSticker({ className }) {
    const { t } = useTranslation();
    return (_jsx("div", { className: `${className ?? ""} bg-background/50 text-foreground flex flex-row items-center gap-[0.3em] rounded-sm px-[0.6em] py-2 text-[calc(var(--sticker-h)*0.4)] leading-none text-nowrap`, children: t("coming-soon") }));
}
export function LockedSticker({ className }) {
    return (_jsx(Button, { variant: "outline", disabled: true, className: `${className ?? ""} text-background flex aspect-square items-center justify-center rounded-full bg-white/10 p-0 text-[calc(var(--sticker-h)*0.4)]`, children: _jsx(Lock, { className: "h-[1em] w-[1em] text-gray-200" }) }));
}
